import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { useAuthStore } from './auth'

export const useUserStore = defineStore('user', () => {
  const authStore = useAuthStore()
  const is2FAEnabled = ref(false)

  const userName = computed(() => {
    return authStore.user?.first_name || authStore.user?.last_name
      ? `${authStore.user?.first_name || ''} ${authStore.user?.last_name || ''}`.trim()
      : authStore.user?.username || 'Utilisateur'
  })

  const email = computed(() => {
    return authStore.user?.email || 'email@example.com'
  })

  const memberSince = computed(() => {
    const joined = (authStore.user as any)?.created_at
    if (!joined) return 'N/A'
    const date = new Date(joined)
    return date.toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' })
  })

  const userId = computed(() => {
    return authStore.user?.id
  })

  const toggle2FA = () => {
    is2FAEnabled.value = !is2FAEnabled.value
  }

  const changeUserName = (firstName: string, lastName: string) => {
    if (authStore.user) {
      authStore.user.first_name = firstName
      authStore.user.last_name = lastName
    }
  }

  return {
    userName,
    email,
    memberSince,
    userId,
    is2FAEnabled,
    toggle2FA,
    changeUserName,
  }
})
